import { useQuery } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { UserType } from "types/UsersTypes";
import { useLogout } from "hooks/auth/";
import { queryClient } from "App";
import { useNavigate } from "react-router";
import { ROUTE_ENUM } from "enums";

export function useGetMe() {
  const navigate = useNavigate();
  const { mutate: logout } = useLogout({});
  return useQuery({
    queryKey: ["me"],
    queryFn: async () => {

      try {
        const response = await axiosInstance.get("/users/me");
        if(!response.data.user.rodoAcceptedAt && window.location.pathname !== ROUTE_ENUM.HOME && response.data.user.role !== 'admin' ) {
          navigate(`${ROUTE_ENUM.RODO}?uuid=${response.data.user.uuid}`);
        }
        return response.data;
      } catch (firstError) {
        try {
          const response = await axiosInstance.get("/users/me");
          return response.data;
        } catch (secondError) {

          const path = window.location.pathname;
          const search = window.location.search;
          const params = new URLSearchParams(search);
          const isSuccReset = path.includes(ROUTE_ENUM.SUCCESSOR_RESET_PASSWORD);
          const token = params.get("token");
          if (
            (queryClient.getQueryData(["me"]) &&
            window.location.href.includes("dashboard"))
          ) {
            if(isSuccReset && token) {
              sessionStorage.setItem("succesorResetToken", token);
            }
            logout();
          }
          throw secondError;
        }
      }
    },
    staleTime: 10000,
    select: (data: { user: UserType }) => data.user,
    retry: 0,
  });
}
